import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
      title: '广州丰享科技服务有限公司',
      isShowFooter: false,
      seq: '1'
  },
  mutations: {
    changeFooterStatus(state, status){
        state.isShowFooter = status;
    }
  },
  actions: {}
});
